import {IObject3D} from '../../Interfaces';
import {RectForPicket} from './RectForPicket';
declare let THREE: any;

export class Picket extends (THREE.Object3D as { new(): IObject3D; }) {

  constructor() {
    super();
  }

  update() {
    const children = this.children.filter(ch => ch instanceof RectForPicket);
    children.forEach(ch => ch.updateTextureRotation(this.getRoot()));
  }

  getRoot(): IObject3D {
    return this;
  }

  getSize(): number {
    return 10;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/Picket.ts